import {Carousel, Image} from 'react-bootstrap';
import createReactClass from 'create-react-class';
import './HelpApp.css';
import '../App/Common.css';

import slide1 from './slides/slide1.PNG';
import slide2 from './slides/slide2.PNG';
import slide3 from './slides/slide3.PNG';
import slide4 from './slides/slide4.PNG';
import slide5 from './slides/slide5.PNG';
import slide6 from './slides/slide6.PNG';
import slide7 from './slides/slide7.PNG';
import slide8 from './slides/slide8.PNG';

var HelpApp = createReactClass({
  getInitialState() {
    return {
      index: 0
    };
  },

  handleSelect(selectedIndex) {
    this.setState({
      index: selectedIndex
    });
  },

  render() {
    return (
      <div className="center">
        <Carousel
          activeIndex={this.state.index}
          onSelect={this.handleSelect}
          indicators={true}
          wrap={false}
          variant="dark"
          slide={true}
          interval={null}
        >
          <Carousel.Item>
            <Image src={slide1} />
          </Carousel.Item>

          <Carousel.Item>
            <Image src={slide2} />
          </Carousel.Item>

          <Carousel.Item>
            <Image src={slide3} />
          </Carousel.Item>

          <Carousel.Item>
            <Image src={slide4} />
          </Carousel.Item>

          <Carousel.Item>
            <Image src={slide5} />
          </Carousel.Item>

          <Carousel.Item>
            <Image src={slide6} />
          </Carousel.Item>

          <Carousel.Item>
            <Image src={slide7} />
          </Carousel.Item>

          <Carousel.Item>
            <Image src={slide8} />
          </Carousel.Item>
        </Carousel>
      </div>
    );
  }
});

export default HelpApp;
